import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import Loader from "react-loader-spinner";
import Tooltip from "@material-ui/core/Tooltip";
import { Alert } from "@material-ui/lab";
import IconButton from "@material-ui/core/IconButton";
import AddCircleIcon from '@mui/icons-material/AddCircle';
// Material UI Components
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import RightDrawer from "views/Usermanagement/components/RightDrawer";
import { Api } from "config/api";
import { SDCloudBackendAPIWithToken } from "apis/backendAPI";
import Badge from "../../../Components/badge";
// Local
import ProfileTable from "views/Usermanagement/components/ProfileTable";
import theme from "theme";
const useStyles = makeStyles((theme) => ({
  loader: {
    color: theme.palette.primary.main,
  },
  gridContainer: {
    padding: "0 40px",
  },
  radioButton: {
    "& .MuiTypography-root": {
      marginLeft: "10px",
    },
  },
  formControl: {
    width: "100%",
    marginTop: "5px",
  },
  warningNote: {
    "& .MuiAlert-icon": {
      display: "none",
    },
  },
}));

const ViewPermissionProfile = (props) => {
  const classes = useStyles();

  // States
  const [isDetailsLoaded, setIsDetailsLoaded] = useState(false);
  const [profileData, setProfileData] = useState([]);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState("");
  const [notificationType, setNotificationType] = useState("");
  const [requestedQuota, setRequestedQuota] = useState({});

  useEffect(() => {
    renderTemplateData();
  }, [props.profile, props.profileData]);

  const hasBadge = profileData.some((item) => item.badge === true);
  const hasQuotaExhausted = profileData.some((item) => item.quota_exhausted === true);

  const columns = [
    {
      Header: "Resource Name",
      accessor: "resource_name",
    },
    {
      Header: "Resource Type",
      accessor: "resource_type",
    },
    {
      Header: "Permission",
      accessor: "permission",
    },
    {
      Header: "Lab Hours",
      accessor: "lab_hours",
    },
    {
      Header: "Allocated Hours",
      accessor: "allocated_hours",
    },
    {
      Header: "Consumed Hours",
      accessor: "consumed_hours",
    },
    {
      Header: "Allocated Quota",
      accessor: "allocated_quota",
    },
    {
      Header: "Available Quota",
      accessor: "available_quota",
    },
    ...(hasQuotaExhausted
      ? [
          {
            Header: "Quota Action",
            accessor: "quota_exhausted",
            Cell: ({ value, row }) => {
              if (value === true) {
                const disabled = requestedQuota[row.original.resource_name] === true || row.original.quota_msg === true;;
                return (
                  <Tooltip title={disabled ? "Request already sent" : "Request for quota"}>
                    <span>
                      <IconButton
                        color="primary"
                        size="small"
                        onClick={() =>
                          requestQuota(
                            row.original.resource_name,
                            row.original.resource_type
                          )
                        }
                        disabled={disabled}
                      >
                        <AddCircleIcon />
                      </IconButton>
                    </span>
                  </Tooltip>
                );
              }
              return null;
            },
          },
        ]
      : []),

    ...(hasBadge
      ? [
          {
            Header: "Badge",
            accessor: "badge",
            Cell: ({ value, row }) => {
              if (value) {
                return (
                  <Badge
                    labName={row.original.resource_name}
                    badgeUrl={row.original.badgeUrl}
                    logo={value}
                  />
                );
              }
              return null;
            },
          },
        ]
      : []),
  ];

  const requestQuota = async (resource_name, resource_type) => {
    setRequestedQuota((prev) => ({ ...prev, [resource_name]: true }));
    await SDCloudBackendAPIWithToken()
      .post(Api.requestQuota, {
        resource_name: resource_name !== "Designer" ? resource_name : "designer_portal",
        resource_type: resource_type,
        profile_name: props.profileName
      })
      .then((res) => {
        setShowNotification(true);
        setNotificationType("success");
        setNotificationMessage("Quota request successfully sent");
      })
      .catch((err) => {
        let message = err.response.data.message;
        setShowNotification(true);
        setNotificationType("error");
        setNotificationMessage(message);
        setRequestedQuota((prev) => ({ ...prev, [resource_name]: false }));
      });
  }
  const renderTemplateData = async () => {
    await SDCloudBackendAPIWithToken()
      .post(Api.getProfile)
      .then((res) => {
        let profileInfo = res.data.profiles[0].permissions.map((item) => {
          return {
            resource_name: item.display_name
              ? item.display_name
              : item.resource_name === "designer_portal"
              ? 'Designer'
              : item.resource_name,
            resource_type: item.is_scripted_demo
              ? "showcase"
              : item.resource_type,
            permission: item.permission,
            lab_hours: item.labhours,
            allocated_hours: item.allocated_hours,
            consumed_hours: item.consumed_hours.toFixed(2),
            allocated_quota: item.allocated_quota,
            available_quota: item.available_quota != null ? item.available_quota.toFixed(2): null,    // Math.floor(item.quota),
            badge:item.is_badge,
            quota_exhausted: item.quota_exhausted,
            quota_msg:item.quota_msg,
            badgeUrl:item.badge_url
          };
        });
        setProfileData(profileInfo);
        setIsDetailsLoaded(true);
      });
  };

  return (
    <div>
      <RightDrawer
        open={props.openDrawer}
        onClose={props.setCloseDrawer}
        title={"Profile details"}
      >
        <Grid container className={classes.gridContainer}>
          <Grid item md={12}>
            <Typography variant="h4">{props.profileName}</Typography>
          </Grid>
          {!isDetailsLoaded ? (
            <Grid container justify="center" style={{ marginTop: "100px" }}>
              <Loader
                type="ThreeDots"
                color={theme.palette.secondary.main}
                height={50}
                width={50}
                visible={true}
              />
            </Grid>
          ) : (
            <Grid item xs={12} md={12} style={{ marginTop: "35px" }}>
              <Grid container justify="space-between">
                <ProfileTable
                  columns={columns}
                  data={profileData}
                  // tableTitle="Available Templates"
                  // buttonTitle="Create Profile"
                  dropDownValues={[]}
                  hiddenColumns={["template_name"]}
                />
              </Grid>
            </Grid>
          )}
        </Grid>

        {/* </Grid> */}
        <Grid container justifyContent="center">
          <Grid item xs={12} md={8}>
            {showNotification ? (
              <Alert
                onClose={() => setShowNotification(false)}
                severity={notificationType}
                style={{ textAlign: "center" }}
              >
                {notificationMessage}
              </Alert>
            ) : null}
          </Grid>
        </Grid>
      </RightDrawer>
    </div>
  );
};

export default ViewPermissionProfile;